// extracted by mini-css-extract-plugin
module.exports = {"container":"StockInfoView_container__2IVkh","nav":"StockInfoView_nav__29MnT","content":"StockInfoView_content__XVFc8"};